import PromoMaterialsTable from './PromoMaterialsTable';

export default PromoMaterialsTable;
